export default "__VITE_ASSET__a3cd7032__"